import PortraitIcon from '@mui/icons-material/Portrait';
import useCustomerActions from '../../../hooks/useCustomerActions';
import { HeaderActionButton, HeaderActionButtonProps } from './HeaderActionButton';

type MyCustomerHomeButtonProps = HeaderActionButtonProps;

export function MyCustomersHomeButton(props: MyCustomerHomeButtonProps) {
    const { clickMyCustomersHome } = useCustomerActions();

    return (
        <HeaderActionButton
            onClick={clickMyCustomersHome}
            {...props}
        >
            <PortraitIcon />
        </HeaderActionButton>
    );
}
